// import config from '../config';
// import RestStore from './RestStore';
import RdsStore from './RdsStore';

// let store;
// let _store;
// if (config.store === 'restStore') {
//   store = new RestStore();
// }
// if (!window.indexedDB) {
//   _store = new RestStore();
// } else {
//   _store = new RdsStore();
// }
export default new RdsStore();
